//
// Module for Subscription Defaults Edit view
//
rs.module("fund/configuration/salarycategories/index",

    ["controls/data/grid", "common/visibility"],

    function (gridModule, visibility) {
        function initialize(fasGridLrsApi, contributionGridLrsApi, jsSelectors, ajaxUrls) {
            var fasForm = $.js(jsSelectors.fasForm);
            var fasTerminateSelected = fasForm.js(jsSelectors.fasTerminateSelected);
            var fasTerminationDate = fasForm.js(jsSelectors.fasTerminationDate);
            var fasTerminateModal = fasForm.js(jsSelectors.fasTerminateModal);
            var fasFilter = fasForm.js(jsSelectors.fasFilter);
            var fasAsOfDate = fasFilter.js(jsSelectors.fasAsOfDate);
            var fasLoadingSpinner = fasFilter.js(jsSelectors.fasLoadingSpinner);
            var fasSelectionError = fasForm.js(jsSelectors.fasSelectionError);

            var contributionForm = $.js(jsSelectors.contributionForm);
            var contributionTerminateSelected = contributionForm.js(jsSelectors.contributionTerminateSelected);
            var contributionTerminationDate = contributionForm.js(jsSelectors.contributionTerminationDate);
            var contributionTerminateModal = contributionForm.js(jsSelectors.contributionTerminateModal);
            var contributionFilter = contributionForm.js(jsSelectors.contributionFilter);
            var contributionAsOfDate = contributionFilter.js(jsSelectors.contributionAsOfDate);
            var contributionLoadingSpinner = contributionFilter.js(jsSelectors.contributionLoadingSpinner);
            var contributionSelectionError = contributionForm.js(jsSelectors.contributionSelectionError);

            // hide errors after selecting a record
            fasGridLrsApi.selectionChanged(function (values, rows) {
                if (fasGridLrsApi.selectedRows.length > 0) {
                    visibility.hide(fasSelectionError);
                }
            });

            // show the modal or an error on click
            fasTerminateSelected.click(function () {
                if (fasGridLrsApi.selectedRows.length > 0) {
                    fasTerminationDate.val("");
                    fasTerminateModal.modal('show');
                }
                else {
                    visibility.show(fasSelectionError);
                }
            });

            // Hook up click event on the radio buttons to reload the grid data via ajax
            fasAsOfDate.find("input").on('click', function () {
                fasLoadingSpinner.show();

                // Update grid
                gridModule.update(
                    ajaxUrls.fasGridData,

                    { currentOnly: fasAsOfDate.find("input:checked").val() },

                    fasGridLrsApi.agGridApi,

                    function done() {
                        fasLoadingSpinner.hide();
                    }
                );
            });

            // hide errors after selecting a record
            contributionGridLrsApi.selectionChanged(function (values, rows) {
                if (contributionGridLrsApi.selectedRows.length > 0) {
                    visibility.hide(contributionSelectionError);
                }
            });

            // show the modal or an error on click
            contributionTerminateSelected.click(function () {
                if (contributionGridLrsApi.selectedRows.length > 0) {
                    contributionTerminationDate.val("");
                    contributionTerminateModal.modal('show');
                }
                else {
                    visibility.show(contributionSelectionError);
                }
            });

            // Hook up click event on the radio buttons to reload the grid data via ajax
            contributionAsOfDate.find("input").on('click', function () {
                contributionLoadingSpinner.show();

                // Update grid
                gridModule.update(
                    ajaxUrls.contributionGridData,

                    { currentOnly: contributionAsOfDate.find("input:checked").val() },

                    contributionGridLrsApi.agGridApi,

                    function done() {
                        contributionLoadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
)